export default __webpack_public_path__ + "static/media/286.661a02bd.png";